import axios from "axios";
import {API_ROOT} from "../app/utils";
import {getSharingDetailsPopup} from './sharingDetailsActions';

export function contactContent(string) {
    return {
        type: "CONTACT_CONTENT",
        payload: string
    };
}

export function findContactDetails(contactId, userContactType){
    return function (dispatch, getState) {

        let ownerId = '';
        let request = '';

        const myObj = getState().contactReducer.contactCardDetails;

        if(Object.keys(myObj).length>1){
            ownerId = getState().contactReducer.contactCardDetails.ownerId;
            request = API_ROOT + '/api/contact/' + contactId +'?ownerId=' + ownerId +'&userContactType=' + userContactType +'&isMaxTargetLabel=true'
        } else {
            if(window.location.pathname.includes('/contact/')){
                request = API_ROOT + '/api/contact/' + contactId +'?userContactType=' + userContactType;
            }
        }

        axios.get(request, {withCredentials: true}).then( response => {
            dispatch({
                type: "FIND_CONTACT_DETAILS",
                payload: response.data
            });
        }).catch((err)=>{
	        dispatch({
		        type: "FIND_CONTACT_DETAILS",
		        payload: err.response.data
	        });

            if(err.response.status === 404){
                dispatch(getSharingDetailsPopup([true, "contact_not_found"]));
            }
        })
    }
}

export function resetFindContactDetails() {
    return {
        type: 'FIND_CONTACT_DETAILS',
        payload: null
    }
}

export function addToOtherLabel(boolean){
	return {
		type: "ADD_TO_OTHER_LABEL",
		payload: boolean
	};
}
